export interface Holiday {
  readonly date: string; // YYYY-MM-DD
  readonly name: string;
}

interface HolidayResponse {
  readonly year: number;
  readonly holidays: readonly Holiday[];
}

const cache = new Map<number, readonly Holiday[]>();

// 祝日を取得(CORS 可)。年単位メモ化。失敗時は空配列(カレンダーは祝日なしで描画継続)。
export async function fetchHolidays(year: number, fetchImpl: typeof fetch = fetch): Promise<readonly Holiday[]> {
  const cached = cache.get(year);
  if (cached !== undefined) return cached;
  try {
    const res = await fetchImpl("https://holiday-api.shinonome.co.jp/" + year + "/holidays");
    if (!res.ok) return [];
    const data = (await res.json()) as HolidayResponse;
    const holidays = data.holidays ?? [];
    cache.set(year, holidays);
    return holidays;
  } catch {
    return [];
  }
}
